var App = App || {};

App.Community = (function ($) {
    "use strict";

    function init() {
        var $counter = $(".counter"),
            counterArray = [];

        $counter.each(function () {
            var $this = $(this);

            counterArray.push(new Odometer({
                animation: "count",
                el: this,
                value: $this.data("start"),
                endValue: $this.data("end"),
                format: $this.data("format"),
                duration: 2500
            }));

            if (counterArray.length > 0) {
                $(window).on("load scroll", function () {
                    if ($(window).scrollTop() > $counter.offset().top - $(window).height()) {
                        $.each(counterArray, function () {
                            this.update(this.options.endValue);
                        });
                    }
                });
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Community.init();
});